<template>
  <div>
    <ejs-grid ref='modRecordsGrid'
      @rowSelected='modRecordsChanged'
      @rowDeselected='modRecordsChanged'
      :dataSource='modRecords'
      :columns='modColumns'
      gridLines='Vertical'>
    </ejs-grid>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'ModRecords',
  props: {
    modRecords: {
      type: Array,
      default() {
        return [];
      },
    },
    modColumns: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
    };
  },
  // 切换组件时，清空已勾选数据缓存
  beforeDestroy() {
    this.changeMassChkedRecords([]);
  },
  methods: {
    ...mapMutations(['changeMassChkedRecords']),
    clearSelectedRows() {
      this.$refs.modRecordsGrid.clearRowSelection();
    },
    modRecordsChanged() {
      const checkedRecords = this.$refs.modRecordsGrid.getSelectedRecords();
      this.changeMassChkedRecords(checkedRecords);
    },
    getCheckedRecords() {
      return this.$refs.modRecordsGrid.getSelectedRecords();
    }
  }
};
</script>

<style>

</style>